/** Kapsamlı kullanıcının gördüğü iş emri ve müşteri ekranları. Dil seçici yok. */

const COLUMN_EN = {
  "İş Emri No": "Work Order No",
  "Başlangıç Tarihi": "Start Date",
  "Bitiş Tarihi": "End Date",
  "Personel": "Staff",
  "Müşteri": "Customer",
  "Müşteri ID": "Customer ID",
  "Müşteri Adı": "Customer",
  "Lokasyon": "Location",
  "Lokasyon Adı": "Location",
  "Makine": "Machine",
  "Makine Adı": "Machine",
  "UYF No": "UYF No",
  "Seri No": "Serial No",
  "İletilen Problemler": "Reported Problems",
  "Temsilci": "Representative",
  "Müşteri Temsilcisi": "Representative",
  "Günlük Rapor": "Daily Report",
  "Ziyaretçi Raporu": "Visit Report",
  "Durum": "Status",
  "Tip": "Type",
  "Ülke": "Country",
  "Şehir": "City",
  "Yetkili": "Contact",
  "kategori": "Category",
  "Email": "Email",
  "WWW": "Website",
};

const HEADER_EN = {
  "Work Order No": "WO No",
  "Start Date": "Start",
  "End Date": "End",
  "Reported Problems": "Problems",
  "Daily Report": "Daily",
  "Visit Report": "Visit",
  "Customer ID": "Cust. ID",
};

const TITLE_EN = {
  "Tüm İş Emirleri": "All Work Orders",
  "Taslak İş Emirleri": "Draft Work Orders",
  "Talepler": "Requests",
  "Final İş Emirleri": "Final Work Orders",
  "Devam Eden İş Emirleri": "Ongoing Work Orders",
  "Pasif Devam Eden İş Emirleri": "On Hold Work Orders",
  "Tamamlanan İş Emirleri": "Completed Work Orders",
  "İptal İş Emirleri": "Cancelled Work Orders",
  "Müşteriler": "Customers",
};

const MENU_EN = {
  "İş Emirleri": "Work Orders",
  "Müşteriler": "Customers",
  "İş Emri Ekle": "Add Work Order",
  "Tüm İş Emirleri": "All Work Orders",
  "Talep İş Emirleri": "Requested Work Orders",
  "Taslak İş Emirleri": "Draft Work Orders",
  "Final İş Emirleri": "Final Work Orders",
  "Devam Eden İş Emirleri": "Ongoing Work Orders",
  "Pasif Devam İş Emirleri": "On Hold Work Orders",
  "Tamamlanan İş Emirleri": "Completed Work Orders",
  "İptal İş Emirleri": "Cancelled Work Orders",
  "Müşteri Listesi": "Customer List",
  "Çıkış": "Log out",
  "Coiltech Servis": "Coiltech Service",
  "Menü": "Menu",
  "Menüyü kapat": "Close menu",
};

const STATUS_EN = {
  Final: "Final",
  Devam: "Ongoing",
  "Pasif Devam": "On Hold",
  Tamamlandi: "Completed",
  Iptal: "Cancelled",
  Taslak: "Draft",
  talep: "Request",
};

export function currentLang() {
  try {
    return localStorage.getItem("ct_lang") === "en" ? "en" : "tr";
  } catch (err) {
    return "tr";
  }
}

export function columnLabel(original) {
  if (currentLang() !== "en") return original;
  return COLUMN_EN[original] || original;
}

export function englishHeaderShort(fullLabel) {
  return HEADER_EN[fullLabel] || null;
}

export function pageTitle(turkish) {
  if (currentLang() !== "en") return turkish;
  return TITLE_EN[turkish] || turkish;
}

export function menuText(turkish) {
  if (currentLang() !== "en") return turkish;
  return MENU_EN[turkish] || turkish;
}

export function statusLabel(value) {
  if (value == null || currentLang() !== "en") return value;
  return STATUS_EN[value] || value;
}

export function reportLinkText(index) {
  if (currentLang() !== "en") return index ? `Rapor ${index}` : "Rapor";
  return index ? `Report ${index}` : "Report";
}
